/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { CmlContent } from '__generated__/graphql-types-do-not-use';

import { CheckIcon } from '@coursera/cds-icons';

import CML from 'bundles/unified-description-page-common/components/shared/CML';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

type Props = {
  objective: CmlContent;
};

const styles = {
  objective: css`
    display: flex;
    flex-direction: row;
    gap: var(--cds-spacing-150);
  `,
  icon: css`
    flex-shrink: 0;
  `,
};

// This component renders one single learning objective
const LearningObjective = ({ objective }: Props) => {
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  return (
    <div css={styles.objective}>
      <CheckIcon size={enableXDPRedesign ? 'medium' : 'large'} css={styles.icon} />
      <CML cml={objective} />
    </div>
  );
};

export default LearningObjective;
